export default __webpack_public_path__ + "static/media/NASA_08.a2793694.png";